module.exports = __webpack_public_path__ + "img/avatar-default.d70bb445.jpg";